import state from './state.js'
import { validateEmail } from '../../lib/utils/index.js'

/**
 * Signs up customer to klaviyo
 */
export const signupCustomer = async () => {
  const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${HH_QUIZ.klaviyo.company_id}`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        revision: '2022-02-16'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
              list_id: state.quiz.klaviyoListId,
              custom_source: "Quiz",
              email: state.customer.email
          }
        }
      }),
    })
  if (response.status === 202) state.updateCustomer({ signupEmail: state.customer.email })

  return response
}

/**
 * Signs up customer to klaviyo, if conditions are met
 */
let _signupCustomerTimeout = null;

export const trySignupCustomer = () => {
  clearTimeout(_signupCustomerTimeout)
  _signupCustomerTimeout = setTimeout(async () => {
    if (
      !state.customer.signupOptIn ||
      !HH_QUIZ.klaviyo.company_id ||
      !state.quiz.klaviyoListId ||
      state.customer.email === state.customer.signupEmail ||
      !validateEmail(state.customer.email)
    ) return;
    await signupCustomer();
  }, 500)
}

export default trySignupCustomer;